import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'pn-site-footer-col',
  styleUrl: 'pn-site-footer-col.scss',
})
export class PnSiteFooterCol {
  @Prop({ reflect: true }) theme: string = null;

  render() {
    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
